<template>
    <div id="content" v-if="isLoaded">
        <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           :popup-message="getPopupMessage"
           @popup-action="_executePopupAction"
        />

        <div class="inner">
            <p class="buttons" v-if="this.entity.id">
                <a v-if="$_updateActionAllowed & entity.system && entity.is_modified" @click.stop="_resetChannelGroup" class="btn btn_action btn_grey btn_reset" :title="$gettext('Resetovat skupinu')" v-translate>Resetovat</a>
                <a v-if="$_updateActionAllowed & !entity.system" @click.stop="_deleteChannelGroup" class="btn btn_action btn_delete" :title="$gettext('Smazat skupinu')" v-translate>Smazat</a>
            </p>
            <h1>
              {{title}}
              <span> | {{ subscriber.name }}</span>
            </h1>
        </div>

        <div class="responsiveTabs">
            <div class="tabs_content">
                <section>
                    <div class="left">
                      <detail-entity-info
                          :entity="entity"
                          :omit-default="['id']"
                      >
                        <p><translate class="translate">ID</translate>: <span class="date">{{ entity.id_group }}</span></p>
                        <p><translate class="translate">Typ skupiny</translate>: <span class="date">{{ groupType}}</span></p>
                        <p v-if="entity.system"><translate class="translate">Typ systémové skupiny</translate>: <span class="date">{{ systemGroupType}}</span></p>
                        <p v-if="entity.thematic_group_name"><translate class="translate">Vychází z tématické skupiny</translate>: <a @click="openThematicGroupDetail(entity.thematic_group_id)">{{ entity.thematic_group_name}}</a></p>
                      </detail-entity-info>
                    </div>

                    <div class="right">
                        <div class="field_left">
                            <p class="field">
                                <label for="nazevSkupiny" v-translate>Název skupiny</label>
                                <input
                                    :placeholder="$gettext('Např. Skupina v obýváku')"
                                    id="nazevSkupiny"
                                    name="nazevSkupiny"
                                    size="30"
                                    v-model="entity.name"
                                    type="text"
                                    :disabled="!$_updateActionAllowed"
                                />
                            </p>
                          <p class="field">
                            <select-box id="profile"
                                        v-model="entity.id_subscriber_profile"
                                        :options="profileOptions"
                                        ref="profileref"
                                        :disabled="!$_updateActionAllowed"
                            ><translate class="translate">Profil odběratele</translate>
                            </select-box>
                          </p>
                        </div>
                    </div>
                </section>

                <device-list v-if="showDeviceList" :entity="entity" :devices="allDevices"/>

                <channel-lists :entity="entity" :all-channels="allChannels" />

                <section class="buttons">
                    <p>
                        <a @click.stop="_goBack" class="btn btn_back btn_seznam" v-translate>Seznam</a>

                        <input v-if="$_updateActionAllowed" @click.stop="_storeChannelGroup(false)" :class="{btn_inactive: !isUpdated }" class="btn" type="submit" :value="$gettext('Uložit skupinu')">
                        <input v-if="$_updateActionAllowed" @click.stop="_storeChannelGroup(true)" :class="{btn_inactive: !isUpdated }" class="btn btn_back" type="submit" :value="$gettext('Uložit skupinu a zpět')">
                    </p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import DeviceList from "./detail/deviceList";
import ChannelLists from "./detail/channelLists";

import popup from "@/components/mixins/popup"
import Popup from "@/components/common/Popup"

import message from "@/components/mixins/message"
import DetailEntityInfo from "../../common/DetailEntityInfo.vue";

export default {
    name: "channelGroupDetail",
    components: {DetailEntityInfo, ChannelLists, DeviceList, Popup},
    mixins: [message, popup],
    data() {
        return {
            entity: null,
            isLoaded: false,
            allDevices: [],
            allChannels: [],
            subscriber: null,
            isUpdated: false,
            profileOptions: [],
            showDeviceList: true
        }
    },
    created(ChannelGroupService, SubscriberProfileService) {
        this.channelGroupService = ChannelGroupService;
        this.subscriberProfileService = SubscriberProfileService;
        this._initChannelGroup();
    },
    computed: {
      title(){
        return this.entity.id ? this.entity.name : this.$gettext("Nová skupina stanic");
      },
      groupType(){
        return this.entity.system ? this.$gettext('Systémová skupina') : this.$gettext('Uživatelská skupina');
      },
      systemGroupType(){
        switch(this.entity.type){
          case 'tv':
            return this.$gettext('Televize');
          case 'radio':
            return this.$gettext('Rádio');
          case 'combined':
            return this.$gettext('Kombinovaná');
          default:
            return this.$gettext('Neznámý typ');
        }
      },
    },
    methods: {
      openThematicGroupDetail(idThematicGroup) {
        this.$router.push({
          name: 'thematicGroupDetail',
          params: {
            id: idThematicGroup
          }
        });
      },
        _initChannelGroup() {
            if (!this.$route.meta.isNewGroup) {
              this._getChannelGroupById(this.$route.params.idGroup);
            } else {
              this._createNewChannelGroup();
            }
        },
        _getSubscriberProfileOptions(){
          this.subscriberProfileService.getSelectboxList(this.subscriber.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
              .then(data => {
                this.profileOptions = data['subscriber_profiles'];
                let index = this.profileOptions.findIndex((profile)=> {
                  return profile.id === null
                });
                this.profileOptions[index].text = this.$gettext("Výchozí profil odběratele");
              });
        },
        _getChannelGroupById(idGroup) {
            this.isLoaded = false;

            let promise = null;

            if (this.$route.meta.isDeviceGroup) {
                promise = Promise.all([
                    this.channelGroupService.getEntity(idGroup, {id_selected_operator: this.$_loggedUser_selectedOperatorId}),
                    this.channelGroupService.getBasicDataByIdDevice(this.$route.params.idDevice),
                ]);
            } else {
                promise = this.channelGroupService.getEntity(idGroup, {id_selected_operator: this.$_loggedUser_selectedOperatorId}).then((channelGroupResponse) => {
                    return this.channelGroupService.getBasicDataByIdSubscriber(channelGroupResponse.channel_group.id_subscriber).then((basicDataResponse) => {
                        return [channelGroupResponse, basicDataResponse];
                    });
                });
            }

            promise.then((response) => {
                this.isLoaded = true;
                this.entity = response[0].channel_group;
                this.allChannels = response[1].channels;
                this.allDevices = response[1].devices;
                this.subscriber = response[1].subscriber;
                this._getSubscriberProfileOptions();
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            });
        },
        _createNewChannelGroup() {
            this.isLoaded = false;
            const isDeviceGroup = this.$route.meta.isDeviceGroup;

            let promise = null;

            if (isDeviceGroup) {
                promise = this.channelGroupService.getBasicDataByIdDevice(this.$route.params.idDevice);
            } else {
                promise = this.channelGroupService.getBasicDataByIdSubscriber(this.$route.params.idSubscriber);
            }

            promise.then((response) => {
                this.isLoaded = true;

                this.allChannels = response.channels;
                this.allDevices = response.devices;
                this.subscriber = response.subscriber;
                this._getSubscriberProfileOptions();

                this.entity = {
                    id: null,
                    id_subscriber_profile: null,
                    id_group: null,
                    device_ids: isDeviceGroup ? [~~this.$route.params.idDevice] : [],
                    channel_ids: [],
                    system: false,
                    name: isDeviceGroup ? response.devices[this.$route.params.idDevice] : ''
                }

                this.isUpdated = true;
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            });
        },
        _storeChannelGroup(goBack) {
            if (this.isUpdated && this.isLoaded) {
                if (this.entity.id) {
                    this._updateChannelGroup(goBack);
                } else {
                    this._createChannelGroup(goBack);
                }
            }
        },
        _updateChannelGroup(goBack) {
            this.setLoadingMessage();

            this.channelGroupService.updateEntity(this.entity.id_group, this.entity).then(() => {
                if (!goBack) {
                    this.setSuccessMessage();
                    this.isUpdated = false;
                } else {
                    this._goBack();
                }
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            })
        },
        _createChannelGroup(goBack) {
            this.setLoadingMessage();

            this.channelGroupService.createEntity({
                id_subscriber: this.subscriber.id,
                id_subscriber_profile: this.entity.id_subscriber_profile ? Number(this.entity.id_subscriber_profile) : null,
                name: this.entity.name,
                device_ids: this.entity.device_ids,
                channel_ids: this.entity.channel_ids
            }).then((response) => {
                if (!goBack) {
                    this.entity.id = response.id;
                    this.entity.id_group = response.id;

                    this.isUpdated = false;
                } else {
                    this._goBack();
                }

                this.setSuccessMessage();
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            })
        },
        _deleteChannelGroup(showPopup = true) {
            if (showPopup) {
                this.showPopup(this.entity, 'delete', 'delete-channel-group');
            } else {
                this.setLoadingMessage();

                this.channelGroupService.deleteEntity(this.entity.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId}).then(() => {
                    this._goBack();
                }).catch((error) => {
                    this.setErrorMessage(this._processDetailErrorMessage(error));
                })
            }
        },
        _resetChannelGroup(showPopup = true) {
          if (showPopup) {
            this.showPopup(this.entity, 'reset', 'reset-channel-group', null, 'Opravdu si přejete resetovat skupinu kanálů?');
          } else {
            this.channelGroupService.resetEntity(this.entity.id_group, {id_selected_operator: this.$_loggedUser_selectedOperatorId}).then(() => {
              this._initChannelGroup();
            }).catch((error) => {
              this.setErrorMessage(this._processDetailErrorMessage(error));
            })
          }
        },
        _executePopupAction(value) {
            if (value) {
                switch(this.getPopupAction) {
                    case 'delete-channel-group':
                        this._deleteChannelGroup(false);
                        break;
                  case 'reset-channel-group':
                    this._resetChannelGroup(false);
                    break;
                }
            }
            this.hidePopup();
        },
        _goBack() {
            if (this.$route.params.idDevice) {
                this._backToDeviceChannelGroups();
            } else {
                this._backToSubscriberChannelGroups();
            }
        },
        _backToDeviceChannelGroups() {
            this.$router.push({
                name: 'deviceChannelGroups',
                params: {
                    id: this.$route.params.idDevice
                }
            });
        },
        _backToSubscriberChannelGroups() {
            this.$router.push({
                name: 'subscriberDetailChannelGroups',
                params: {
                    id: this.subscriber.id
                }
            });
        }
    },
    watch: {
        'entity.name' (newValue, oldValue) {
            if (oldValue) {
                this.isUpdated = true;
            }
        },
        'entity.channel_ids' (newValue, oldValue) {
            if (oldValue) {
                this.isUpdated = true;
                this.entity.is_modified = true;
            }
        },
        'entity.device_ids' (newValue, oldValue) {
            if (oldValue) {
                this.isUpdated = true;
            }
        },
        'entity.id_subscriber_profile' (newValue, oldValue) {
          if (oldValue != newValue) {
            this.isUpdated = true;
            this.showDeviceList = newValue === null;
            this.entity.device_ids = [];
          }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/views/channelGroups/channelGroupDetail.vue